module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","plain-form settings-host-page");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-header");
      var el3 = dom.createElement("button");
      dom.setAttribute(el3,"class","go-back");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h1");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h2");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","explanation");
      var el3 = dom.createElement("p");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("p");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      var el4 = dom.createTextNode(" ");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("span");
      dom.setAttribute(el4,"class","support-link");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","change-host-form");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","host-input-part");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","input-with-prefix");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","prefix");
      var el6 = dom.createTextNode("http://");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","host-input-button");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, element = hooks.element, inline = hooks.inline, get = hooks.get, block = hooks.block, content = hooks.content;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element0 = dom.childAt(fragment, [0]);
      var element1 = dom.childAt(element0, [0]);
      var element2 = dom.childAt(element1, [0]);
      var element3 = dom.childAt(element0, [1]);
      var element4 = dom.childAt(element3, [1]);
      var element5 = dom.childAt(element4, [2]);
      var element6 = dom.childAt(element0, [2]);
      var element7 = dom.childAt(element6, [0]);
      var element8 = dom.childAt(element7, [0]);
      var element9 = dom.childAt(element8, [2]);
      var element10 = dom.childAt(element7, [1]);
      var morph0 = dom.createMorphAt(element2,0,0);
      var morph1 = dom.createMorphAt(dom.childAt(element1, [1]),0,0);
      var morph2 = dom.createMorphAt(dom.childAt(element1, [2]),0,0);
      var morph3 = dom.createMorphAt(dom.childAt(element3, [0]),0,0);
      var morph4 = dom.createMorphAt(element4,0,0);
      var morph5 = dom.createMorphAt(element5,0,0);
      var morph6 = dom.createMorphAt(element4,3,3);
      var morph7 = dom.createMorphAt(element8,1,1);
      var morph8 = dom.createMorphAt(element10,0,0);
      var morph9 = dom.createMorphAt(dom.childAt(element6, [1]),0,0);
      element(env, element2, context, "action", ["cancel"], {"on": "click"});
      inline(env, morph0, context, "t", ["sm_button.back"], {});
      inline(env, morph1, context, "t", ["settings.host.title"], {});
      inline(env, morph2, context, "t", ["settings.host.subtitile"], {});
      inline(env, morph3, context, "t", ["settings.host.explanation.text"], {});
      inline(env, morph4, context, "t", ["settings.host.explanation.before_link"], {});
      element(env, element5, context, "action", ["askSupport"], {"on": "click"});
      inline(env, morph5, context, "t", ["settings.host.explanation.link"], {});
      inline(env, morph6, context, "t", ["settings.host.explanation.after_link"], {});
      block(env, morph7, context, "sm-text-field", [], {"classNames": "large host-input", "saveIsDisabled": get(env, context, "saveIsDisabled"), "classNameBindings": "saveIsDisabled:error:success", "value": get(env, context, "hostname"), "spellcheck": false}, child0, null);
      element(env, element9, context, "bind-attr", [], {"class": ":loader hostCheckIsLoading:-visible"});
      element(env, element10, context, "bind-attr", [], {"class": ":validation-message hostCheckResult:-visible"});
      content(env, morph8, context, "hostCheckResult");
      inline(env, morph9, context, "sm-button", [], {"textTranslation": "sm_button.change", "classNames": "xlarge primary", "isLoading": get(env, context, "organization.isSaving"), "action": "saveOrganization", "disabled": get(env, context, "saveIsDisabled")});
      return fragment;
    }
  };
}()));